var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "home" },
    [_c("TablePage", { attrs: { parentCode: _vm.parentCode } })],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }